import request from '@/axios'

export function notificationListApi (limit, page = 1) {
  return request({
    url: `/ClientUser/notification/notification_list/${limit}?page=${page}`,
    method: 'GET'
  })
}
/* lientUser/notification/notification_read =>post
ClientUser/notification/notification_delete =>post
ClientUser/notification/notification_list/{limit} =>get */


export function notificationRead (query) {
  return request({
    url: '/ClientUser/notification/notification_read',
    method: 'POST',
    data: query
  })
}
  
export function notificationDelete (query) {
  return request({
    url: '/ClientUser/notification/notification_delete',
    method: 'POST',
    data: query
  })
}

export function notification_redirection (customer_id, notification_id) {
  return request({
    url: `/ClientUser/notification/notification_redirection/${customer_id}/${notification_id}`,
    method: 'GET'
  })
}

export function certificate_redirection ( certificate_id) {
  return request({
    url: `/ClientUser/certificate/show/${certificate_id}`,
    method: 'GET'
  })
}